import { AnswerItemType } from 'src/model/card'

const addEndingCard = [
  {
    title: 'Celebrate <br/> Completion',
    type: AnswerItemType.RESULTDEFAULT,
    icon: 'prime:flag-fill',
  },
  {
    title: 'Display <br/> Conditional Feedback',
    type: AnswerItemType.RESULT,
    icon: 'material-symbols:call-split-rounded',
  },
  {
    title: 'Show <br/> Score',
    type: AnswerItemType.SCORECARD,
    icon: 'tabler:number-123',
  },

  {
    title: 'Issue <br/> Badge',
    type: AnswerItemType.BADGE,
    icon: 'streamline:star-badge-solid',
  },
]

export default addEndingCard
